import { useContext } from "react";

import { UniversalBenchmarksContext } from "../context";

export const useUniversalBenchmarksLoader = () => {
  const context = useContext(UniversalBenchmarksContext);

  if (!context) {
    throw new Error(
      "useUniversalBenchmarksLoader can only be used inside UniversalBenchmarksContext",
    );
  }

  return context.loadAdoptedBenchmarks;
};
